import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { getNav } from "@/lib/navConfig";
import { useAuth } from "@/context/AuthContext";
import api, { fileUrl } from "@/lib/api";
import { Loader2, ShieldAlert, FileText } from "lucide-react";

export default function DocumentsExpiring() {
  const { user } = useAuth();
  const [docs, setDocs] = useState(null);
  useEffect(() => { api.get("/documents/expiring?days=90").then(({ data }) => setDocs(data)).catch(() => setDocs([])); }, []);

  return (
    <DashboardLayout nav={getNav(user.role)} title="Document Expiration">
      <p className="text-sm text-slate-500 mb-4">Contractor credentials expiring within 90 days (or already expired).</p>
      {!docs ? <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-blue-600" /></div> :
        docs.length === 0 ? <div className="text-center py-20 bg-white rounded-xl border border-slate-200"><ShieldAlert className="w-10 h-10 text-slate-300 mx-auto" /><p className="mt-3 text-slate-500">No expiring documents. All credentials current.</p></div> : (
          <div className="space-y-2">
            {docs.map((d) => (
              <div key={d.id} className="flex items-center justify-between bg-white border border-slate-200 rounded-xl p-4">
                <div className="flex items-center gap-3">
                  <FileText className={`w-5 h-5 ${d.expired ? "text-rose-600" : "text-amber-500"}`} />
                  <div>
                    <div className="font-medium text-slate-900">{d.doc_type} — {d.contractor_name}</div>
                    <div className="text-xs text-slate-500">{d.original_filename}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className={`text-sm font-semibold ${d.expired ? "text-rose-600" : "text-amber-600"}`}>{d.expired ? "Expired" : "Expires"} {d.expiration_date}</div>
                  <a href={fileUrl(d.storage_path)} target="_blank" rel="noreferrer" className="text-xs text-blue-600">View</a>
                </div>
              </div>
            ))}
          </div>
        )}
    </DashboardLayout>
  );
}
